const BASE_URL = "https://api.mindoeducation.co.id"
export const BASE_URL_V2 = "https://api-v2.mindoeducation.co.id/api/v1"
// const BASE_URL = "http://localhost:8000"
  // process.env.NODE_ENV === "production"
  //   ? "https://api.mindoeducation.co.id"
  //   : "http://localhost:8000"
export const BASE_URL_CLASSROOM = `https://classroom.mindoeducation.co.id`
export const BASE_URL_IMAGE_PROGRAM = `${BASE_URL}/storage/covers`
export const BASE_URL_IMAGE_TESTIMONI = `${BASE_URL}/storage/testimonial`
export const BASE_URL_ICON_FACILITY = `${BASE_URL}/storage/facility`
export const BASE_URL_API = `${BASE_URL}/api`
